import React, { Component } from "react";
import { Card, CardBlock } from "reactstrap";
import { getRequest, postRequest } from "../../utils/apiUtils";
import "./style.css";

class AuditTracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: new Date().getFullYear().toString(),
      stateId: "",
      states: [],
      facilities: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.fetchStates();
  }

  fetchStates = () => {
    getRequest({ url: "/api/get_all_statelist" })
      .then((response) => {
        if (response && response.data && response.data.result) {
          this.setState({ states: response.data.result });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  fetchAuditTracking = () => {
    this.setState({ loading: true });
    const payload = {
      year: this.state.year,
      org_id: "34",
    };
    if (this.state.stateId) {
      payload.state_id = this.state.stateId;
    }

    postRequest({ url: "/api/get_audit_tracking_report", payload })
      .then((response) => {
        if (response && response.data && response.data.success) {
          this.setState({ facilities: response.data.result.facilities || [], loading: false });
        } else {
          this.setState({ facilities: [], loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ facilities: [], loading: false });
      });
  };

  handleYearChange = (e) => {
    this.setState({ year: e.target.value });
  };

  handleStateChange = (e) => {
    this.setState({ stateId: e.target.value });
  };

  handleSearch = () => {
    this.fetchAuditTracking();
  };

  getMonthStatus = (monthlyData, monthNumber) => {
    const month = monthlyData.find((m) => m.month_number === monthNumber);
    if (!month) return { text: "-", className: "" };

    switch (month.status) {
      case "Completed":
        return { text: "Completed", className: "status-completed" };
      case "Rectification Pending":
        return { text: "Rectify Pending", className: "status-rectification" };
      case "Audit Pending":
        return { text: "Audit Pending", className: "status-pending" };
      case "In Progress":
        return { text: "In Progress", className: "status-progress" };
      default:
        return { text: month.status || "-", className: "" };
    }
  };

  getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear; i >= currentYear - 5; i--) {
      years.push(i);
    }
    return years;
  };

  render() {
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    return (
      <div className="view">
        <div className="page-header">
          <h1 className="title">Audit Tracking Report</h1>
          <p className="subtitle">Facility-wise monthly audit and rectification status</p>
        </div>

        <Card className="audit-tracking-card">
          <CardBlock>
            <div className="filter-row">
              <div className="filter-item">
                <label>Year</label>
                <select
                  className="form-control"
                  value={this.state.year}
                  onChange={this.handleYearChange}
                >
                  {this.getYearOptions().map((y) => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>
              <div className="filter-item">
                <label>State</label>
                <select
                  className="form-control"
                  value={this.state.stateId}
                  onChange={this.handleStateChange}
                >
                  <option value="">All States</option>
                  {this.state.states.map((state) => (
                    <option key={state.state_id} value={state.state_id}>
                      {state.state_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="filter-item filter-btn">
                <label>&nbsp;</label>
                <button className="btn btn-search" onClick={this.handleSearch}>
                  Search
                </button>
              </div>
            </div>

            <div className="table-responsive">
              {this.state.loading ? (
                <div className="loading-text">Loading...</div>
              ) : this.state.facilities.length === 0 ? (
                <div className="no-data-text">No data available</div>
              ) : (
                <table className="table tracking-table">
                  <thead>
                    <tr>
                      <th className="facility-col">Facility Name</th>
                      {months.map((m, i) => (
                        <th key={i} className="month-col">{m}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.facilities.map((facility) => (
                      <tr key={facility.facility_id}>
                        <td className="facility-name">{facility.facility_name}</td>
                        {months.map((m, i) => {
                          const status = this.getMonthStatus(facility.monthly_data, i + 1);
                          return (
                            <td key={i} className="month-cell">
                              {status.text !== "-" ? (
                                <span className={`status-badge ${status.className}`}>
                                  {status.text}
                                </span>
                              ) : (
                                <span className="no-data">-</span>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </CardBlock>
        </Card>
      </div>
    );
  }
}

export default AuditTracking;



// WEBPACK FOOTER //
// ./src/views/auditTracking/index.js